import { render } from "./PersistencyManage.vue?vue&type=template&id=cf72bb68"
import script from "./PersistencyManage.vue?vue&type=script&lang=js"
export * from "./PersistencyManage.vue?vue&type=script&lang=js"

import "./PersistencyManage.vue?vue&type=style&index=0&id=cf72bb68&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__